import gql from 'not-graphql-tag';

export const reportOutageBySpListGuestMutation = gql`
  mutation reportOutageBySpListGuest(
    $payload: ReportOutageBySpListGuestRequest!
  ) {
    reportOutageBySpListGuest(payload: $payload) {
      success
    }
  }
`;
export const reportOutageBySpListMutation = gql`
  mutation reportOutageBySpList($payload: ReportOutageBySpListRequest!) {
    reportOutageBySpList(payload: $payload) {
      success
    }
  }
`;
export const getOutageDetailsByZipCodeQuery = gql`
  query getOutageDetailsByZipCode($params: OutageDetailsByZipCodeParams!) {
    getOutageDetailsByZipCode(params: $params) {
      zipCode
      cause
      totalCustomersImpacted
      estimatedRestorationOn
      estimatedRestorationOut
      lat
      long
    }
  }
`;

export const getOutagesByCountyQuery = gql`
  query getOutagesByCounty($params: OutageByCountyParams) {
    getOutagesByCounty(params: $params)
  }
`;

export const getOutagesByCityQuery = gql`
  query getOutagesByCity($params: OutageByCityParams) {
    getOutagesByCity(params: $params)
  }
`;

export const getOutageEventDetailsQuery = gql`
  query getOutageEventDetails($params: OutageEventParams!) {
    getOutageEventDetails(params: $params) {
      totalCustomersImpacted
      crewDispatchedStatus
      estimatedTimeOut
      estimatedTimeOn
      cause
      lat
      long
      isStorm
      noOfReports
      eventStatus
    }
  }
`;

export const submitCommPreferenceMutation = gql`
  mutation submitCommPreference($payload: SubmitCommPreferencesRequest!) {
    submitCommPreferences(payload: $payload) {
      success
    }
  }
`;

export const getContactDetails = gql`
  query getAccountInfo {
    getAccountInfo {
      contactDetails {
        encryptedContactId
        contactType
        contactValue
        isPrimary
      }
    }
  }
`;

export const sendOTLQuery = gql`
  query sendOTL($params: SendOTLRequest!) {
    sendOTL(params: $params) {
      isSuccess
    }
  }
`;

export const getOutageLookupQuery = gql`
  query getOutageLookup($params: OutageLookupParams!) {
    getOutageLookup(params: $params) {
      isAccountExists
      isEligibleToReport
      outageStatusWarnings {
        showConnectionInfo
        showResetInfo
      }
      outages {
        encryptedServicePointId
        totalReports
        crewDispatchStatus
        estimatedTimeOn
        estimatedTimeOut
        hasKnownOutage
        isDueToStorm
        customersAffected
        cause
        isReported
        eventStatus
      }
      encryptedAccountNumber
      encryptedPremiseId
      houseNumber
      multiplePremiseList {
        encryptedValue
        houseNumber
        last4CharAddress
      }
    }
  }
`;

export const getAccountDetails = gql`
  query getAccountDetails(
    $params: AccountDetailParams!
    $commPreferencesParams: CommPreferencesParams!
  ) {
    getAccountDetails(params: $params) {
      accountNumber
      isDefault
      description
      accountType
      isActive
      encryptedPersonId
      mainCustomerName
      serviceConnectivity {
        isDisconnected
        isEligibleForReconnect
        disconnectionDate
      }
      premiseInfo {
        isEligibleForOutage
        encryptedPremiseId
        addressLine1
        addressLine2
        state
        city
        postal
        houseType
        servicePointDetails {
          encryptedServicePointId
          lat
          long
          outageInfo {
            isReported
            totalReports
            crewDispatchStatus
            callbackPhone
            estimatedTimeOn
            estimatedTimeOut
            hasKnownOutage
            isDueToStorm
            callbackRequested
            registeredPhone
            isReported
            customersAffected
            cause
            eventStatus
          }
          meter {
            status
          }
        }
      }
      pspsOutage {
        outageStatus
        outageZone {
          zone
        }
        noOfAffectedCustomers
        isActiveOutage
      }
      commPreferences(commPreferencesParams: $commPreferencesParams) {
        notificationType
        deliveryTypeDetails {
          deliveryType
          contactDetails {
            contactId
            encryptedContactId
            value
            encryptedPreferenceId
            isSelected
          }
        }
      }
    }
  }
`;
